import { HTTPError } from "ky";

export const handleAPIError = (error: any) => {
  return error.message || "Something went wrong";
};

export const extractErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    if (error.startsWith("Failed to fetch")) {
      return "Can't reach the server. Check your connection and try again.";
    }

    return error;
  }

  if (error && typeof error === "object" && "message" in error) {
    return String(error.message);
  }

  return "Something went wrong";
};

export const isNotFoundError = (error: unknown): boolean =>
  error instanceof HTTPError && error.response.status === 404;

const MAX_RETRIES = 3;

/** A query `retry`: a missing record stays missing, anything else gets the usual tries. */
export const retryUnlessNotFound = (
  failureCount: number,
  error: unknown,
): boolean => !isNotFoundError(error) && failureCount < MAX_RETRIES;
